import { createComponent } from "@helpers/admin";
import FooterSectionComponent from "@template/blocks/FooterSection/component";

export const Footer = createComponent({
  label: "Footer",
  component: (props) => (
    <FooterSectionComponent
      newIcons
      {...props}
    />
  ),
  fields: {
    internalLinks: {
      label: "Link Categories",
      type: "array",
      arrayFields: {
        title: {
          label: "Label",
          type: "textarea",
        },
        links: {
          label: "Links",
          type: "array",
          arrayFields: {
            name: {
              label: "Label",
              type: "textarea",
            },
            url: {
              label: "URL",
              type: "textarea",
            },
            title: {
              label: "Title",
              type: "textarea",
            },
            target: {
              label: "Open In New Tab",
              type: "select",
              options: [
                { label: "No", value: "_self" },
                {
                  label: "Yes",
                  value: "_blank",
                },
              ],
            },
          },
        },
      },
    },
    iconGroups: {
      label: "Icons",
      type: "array",
      arrayFields: {
        label: {
          label: "Label",
          type: "textarea",
        },
        icons: {
          label: "Icons",
          type: "array",
          arrayFields: {
            name: {
              label: "Icon",
              type: "icon",
            },
            url: {
              label: "URL",
              type: "textarea",
            },
          },
        },
      },
    },
    contact: {
      label: "Footer",
      type: "object",
      objectFields: {
        name: {
          label: "Name",
          type: "textarea",
        },
        phone_number: {
          label: "Phone Number",
          type: "textarea",
        },
        email: {
          label: "Email",
          type: "textarea",
        },
      },
    },
  },
});
